import * as React from "react";
import { useCallback, useMemo, useState } from "react";
import useAskAssistant from "ai/hooks/useAskAssistant";
import useDisclosure from "util/hooks/useDisclosure";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
export const AssistantSidebarContext = React.createContext(void 0);
export const AssistantToolCallsContext = React.createContext([]);
export const AssistantSidebarProvider = ({ children }) => {
  const [isOpen, { open, close }] = useDisclosure();
  const [widgetSummaryRequest, setWidgetSummaryRequest] = useState(null);
  const sendTelemetry = useSendTelemetry();
  const onSuccess = useCallback(() => {
    setWidgetSummaryRequest(null);
    sendTelemetry(TELEMETRY_EVENT_TYPE.WIDGET_SUMMARY.REQUEST_SUCCESS, {});
  }, [sendTelemetry]);
  const {
    request: generate,
    isLoading: isGenerating,
    isError,
    toolCalls
  } = useAskAssistant({ onSuccess });
  const openWidgetSummary = useCallback(
    (r) => {
      setWidgetSummaryRequest(r);
      open();
    },
    [open]
  );
  const value = useMemo(
    () => ({
      isOpen,
      isGenerating,
      isError,
      close,
      generate,
      openWidgetSummary,
      widgetSummaryRequest
    }),
    [isOpen, isGenerating, isError, close, generate, openWidgetSummary, widgetSummaryRequest]
  );
  return /* @__PURE__ */ React.createElement(AssistantSidebarContext.Provider, { value }, /* @__PURE__ */ React.createElement(AssistantToolCallsContext.Provider, { value: toolCalls }, children));
};
